import {
	hiprint
} from 'vue-plugin-hiprint'

export default function(options) {
	var addElementTypes = function(context) {
		// 移除 旧的 defaultModule "元素"类型, 以避免重复
		context.removePrintElementTypes("defaultModule");
		// 添加 defaultModule "元素"类型
		context.addPrintElementTypes("defaultModule", [
			// ---------- 常规文本元素（保持不变） ----------
			new hiprint.PrintElementTypeGroup("常规", [{
					tid: "defaultModule.title",
					type: "html", // 改为 html 类型
					title: "标题",
					options: {
						title: "标题", // 右侧属性面板显示的标题（可选）
						// formatter 返回固定HTML内容
						formatter: "function() { return '<div style=\"font-size:18px;text-align:center;font-weight:bold\">测试单据</div>'; }"
					}
				},
				{
					tid: "defaultModule.code",
					type: "text",
					title: "单据编号",
					options: {
						title: "单据编号",
						field: "code",
						testData: "CS2025010100001"
					}
				},
				{
					tid: "defaultModule.userName",
					type: "text",
					title: "业务员",
					options: {
						title: "业务员",
						field: "userName",
						testData: "admin"
					}
				},
				{
					tid: "defaultModule.businessDate",
					type: "text",
					title: "业务日期",
					options: {
						title: "业务日期",
						field: "businessDate",
						testData: "2026-01-01"
					}
				},
				{
					tid: "defaultModule.supplierName",
					type: "text",
					title: "供应商",
					options: {
						title: "供应商",
						field: "supplierName",
						testData: "测试供应商"
					}
				},
				{
					tid: "defaultModule.customerName",
					type: "text",
					title: "客户",
					options: {
						title: "客户",
						field: "customerName",
						testData: "测试客户"
					}
				},
				{
					tid: "defaultModule.payee",
					type: "text",
					title: "收款人",
					options: {
						title: "收款人",
						field: "payee",
						testData: "测试收款人"
					}
				},
				{
					tid: "defaultModule.payer",
					type: "text",
					title: "付款人",
					options: {
						title: "付款人",
						field: "payer",
						testData: "测试付款人"
					}
				},
				{
					tid: "defaultModule.discount",
					type: "text",
					title: "折扣(%)",
					options: {
						title: "折扣(%)",
						field: "discount",
						testData: "100"
					}
				},
				{
					tid: "defaultModule.originalPrice",
					type: "text",
					title: "本单应收",
					options: {
						title: "本单应收",
						field: "originalPrice",
						testData: "1000"
					}
				},
				{
					tid: "defaultModule.amount",
					type: "text",
					title: "折后价格",
					options: {
						title: "折后价格",
						field: "amount",
						testData: "1000"
					}
				},
				{
					tid: "defaultModule.payAmount",
					type: "text",
					title: "本次实收",
					options: {
						title: "本次实收",
						field: "payAmount",
						testData: "1000"
					}
				},
				{
					tid: "defaultModule.deposit",
					type: "text",
					title: "定金",
					options: {
						title: "定金",
						field: "deposit",
						testData: "100"
					}
				},
				{
					tid: "defaultModule.payWay",
					type: "text",
					title: "支付方式",
					options: {
						title: "支付方式",
						field: "payWay",
						testData: "微信"
					}
				},
				{
					tid: "defaultModule.note",
					type: "text",
					title: "备注",
					options: {
						title: "备注",
						field: "note",
						testData: ""
					}
				},
				{
					tid: "defaultModule.warehousing",
					type: "text",
					title: "入库仓库",
					options: {
						title: "入库仓库",
						field: "warehousing",
						testData: ""
					}
				},
				{
					tid: "defaultModule.depotName",
					type: "text",
					title: "仓库",
					options: {
						title: "仓库",
						field: "depotName",
						testData: ""
					}
				}
			]),

			// ---------- 优化后的表格1：商品数据 ----------
			new hiprint.PrintElementTypeGroup("表格", [{
				tid: "defaultModule.commodity",
				type: "table",
				title: "商品数据",
				// 列定义（二维数组，单行表头）
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品名称",
							field: "name",
							width: 180,
							align: "left"
						},
						{
							title: "规格",
							field: "format",
							width: 100,
							align: "center"
						},
						{
							title: "单位",
							field: "unit",
							width: 70,
							align: "center"
						},
						{
							title: "数量",
							field: "quantity",
							width: 80,
							align: "right",
							dataType: "number",
							summary: "sum"
						},
						{
							title: "单价(元)",
							field: "price",
							width: 100,
							align: "right",
							dataType: "number",
							format: "0.00"
						},
						{
							title: "折扣(%)",
							field: "discount",
							width: 80,
							align: "right",
							dataType: "number",
							format: "0"
						},
						{
							title: "金额(元)",
							field: "amount",
							width: 120,
							align: "right",
							dataType: "number",
							format: "0.00",
							summary: "sum"
						}
					]
				],
				options: {
					title: "商品数据",
					field: "commodityDetail", // 数据字段，应为对象数组
					borderType: "full", // 全边框
					stripe: true, // 斑马纹
					headerBackground: "#f5f5f5", // 表头背景色
					headerAlign: "center", // 表头对齐
					rowHeight: 32, // 行高
					testData: [ // 测试数据（含合计行示例）
						{
							serialNo: 1,
							name: "测试商品1",
							format: "120*120",
							unit: "个",
							quantity: 2,
							price: 10,
							discount: 100,
							amount: 20
						},
						{
							serialNo: 2,
							name: "测试商品2",
							format: "200ml",
							unit: "瓶",
							quantity: 1,
							price: 15,
							discount: 90,
							amount: 13.5
						},
						// 合计行（用特殊样式标记，实际使用时动态生成）
						{
							serialNo: "",
							name: "",
							format: "",
							unit: "合计",
							quantity: 3,
							price: "",
							discount: "",
							amount: 33.5,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格2：额外费用 ----------
			new hiprint.PrintElementTypeGroup("表格2", [{
				tid: "defaultModule.extraCost",
				type: "table",
				title: "额外费用",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "费用类型",
							field: "type",
							width: 120,
							align: "left"
						},
						{
							title: "垫付方式",
							field: "advancePayWay",
							width: 100,
							align: "center"
						},
						{
							title: "结算账户",
							field: "payAccount",
							width: 100,
							align: "center"
						},
						{
							title: "金额(元)",
							field: "amount",
							width: 100,
							align: "right",
							dataType: "number",
							format: "0.00",
							summary: "sum"
						},
						{
							title: "备注",
							field: "note",
							width: 150,
							align: "left"
						}
					]
				],
				options: {
					title: "额外费用",
					field: "extraCost",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							type: "包装费",
							advancePayWay: "对方支付",
							payAccount: "微信",
							amount: 50,
							note: ""
						},
						{
							serialNo: 2,
							type: "送货费",
							advancePayWay: "我方垫付",
							payAccount: "现金",
							amount: 30,
							note: "城东仓库"
						},
						{
							serialNo: "",
							type: "",
							advancePayWay: "",
							payAccount: "合计",
							amount: 80,
							note: "",
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格3：物流信息 ----------
			new hiprint.PrintElementTypeGroup("表格3", [{
				tid: "defaultModule.logisticsInfos",
				type: "table",
				title: "物流信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "物流公司",
							field: "companyName",
							width: 120,
							align: "left"
						},
						{
							title: "物流单号",
							field: "code",
							width: 150,
							align: "left"
						},
						{
							title: "收货人",
							field: "receiver",
							width: 100,
							align: "left"
						},
						{
							title: "联系电话",
							field: "telephone",
							width: 120,
							align: "center"
						},
						{
							title: "运费(元)",
							field: "freight",
							width: 100,
							align: "right",
							dataType: "number",
							format: "0.00",
							summary: "sum"
						},
						{
							title: "备注",
							field: "note",
							width: 150,
							align: "left"
						}
					]
				],
				options: {
					title: "物流信息",
					field: "logisticsInfos",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							companyName: "京东快递",
							code: "JD001234567",
							receiver: "王老板",
							telephone: "13800000000",
							freight: 15,
							note: ""
						},
						{
							serialNo: 2,
							companyName: "顺丰速运",
							code: "SF987654321",
							receiver: "李经理",
							telephone: "13911111111",
							freight: 22,
							note: "加急"
						},
						{
							serialNo: "",
							companyName: "",
							code: "",
							receiver: "合计",
							telephone: "",
							freight: 37,
							note: "",
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格4：费用信息 ----------
			new hiprint.PrintElementTypeGroup("表格4", [{
				tid: "defaultModule.otherCostDetail",
				type: "table",
				title: "费用信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "费用类别",
							field: "costName",
							width: 200,
							align: "left"
						},
						{
							title: "金额",
							field: "costAmount",
							width: 150,
							align: "left"
						},
						{
							title: "备注",
							field: "note",
							width: 390,
							align: "left"
						}
					]
				],
				options: {
					title: "费用信息",
					field: "logisticsInfos",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							costName: "运费",
							costAmount: "100",
							note: ""
						},
						{
							serialNo: 2,
							costName: "损耗费",
							costAmount: "100",
							note: ""
						},
						{
							serialNo: "",
							costName: "合计",
							costAmount: "200",
							note: "",
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格4：费用信息 ----------
			new hiprint.PrintElementTypeGroup("表格5", [{
				tid: "defaultModule.financeDetail",
				type: "table",
				title: "费用信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "单据类型",
							field: "type",
							width: 100,
							align: "left"
						},
						{
							title: "单据编号",
							field: "listCode",
							width: 100,
							align: "left"
						},
						{
							title: "单据日期",
							field: "businessDate",
							width: 100,
							align: "left"
						},
						{
							title: "单据金额",
							field: "listAmount",
							width: 80,
							align: "left"
						},
						{
							title: "已核销金额",
							field: "amountPaid",
							width: 80,
							align: "left"
						},
						{
							title: "未核销金额",
							field: "amountUnpaid",
							width: 80,
							align: "left"
						},
						{
							title: "备注",
							field: "note",
							width: 200,
							align: "left"
						}
					]
				],
				options: {
					title: "费用信息",
					field: "logisticsInfos",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							type: "采购单",
							listCode: "XGD2026010100001",
							businessDate:'2026-01-01',
							listAmount:200,
							amountPaid:100,
							amountUnpaid:100,
							note: ""
						},
						{
							serialNo: 2,
							type: "采购单",
							listCode: "XGD2026010100002",
							businessDate:'2026-01-01',
							listAmount:200,
							amountPaid:100,
							amountUnpaid:100,
							note: ""
						},
						{
							serialNo: "",
							type: "合计",
							listCode: "",
							businessDate:'',
							listAmount:400,
							amountPaid:200,
							amountUnpaid:200,
							note: "",
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格6：商品信息 ----------
			new hiprint.PrintElementTypeGroup("表格6", [{
				tid: "defaultModule.commodityAllocationDetail",
				type: "table",
				title: "商品信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品",
							field: "name",
							width: 200,
							align: "left"
						},
						{
							title: "商品规格",
							field: "format",
							width: 210,
							align: "left"
						},
						{
							title: "出库仓库",
							field: "outboundName",
							width: 150,
							align: "left"
						},
						{
							title: "计量单位",
							field: "unit",
							width: 80,
							align: "left"
						},
						{
							title: "数量",
							field: "quantity",
							width: 100,
							align: "left"
						}
					]
				],
				options: {
					title: "商品信息",
					field: "commodityAllocationDetail",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							name: "测试商品",
							format: "120*120",
							outboundName: "五金库",
							unit:'个',
							quantity:10
						},
						{
							serialNo: 2,
							name: "测试商品",
							format: "120*120",
							outboundName: "五金库",
							unit:'个',
							quantity:10
						},
						{
							serialNo: "",
							name: "",
							format: "合计",
							outboundName: "",
							unit:'',
							quantity:20,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格6：商品信息 ----------
			new hiprint.PrintElementTypeGroup("表格7", [{
				tid: "defaultModule.commodityStockDetail",
				type: "table",
				title: "商品信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品",
							field: "name",
							width: 200,
							align: "left"
						},
						{
							title: "商品规格",
							field: "format",
							width: 210,
							align: "left"
						},
						{
							title: "单价",
							field: "price",
							width: 150,
							align: "left"
						},
						{
							title: "计量单位",
							field: "unit",
							width: 80,
							align: "left"
						},
						{
							title: "数量",
							field: "quantity",
							width: 100,
							align: "left"
						}
					]
				],
				options: {
					title: "商品信息",
					field: "commodityStockDetail",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: 2,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: "",
							name: "",
							format: "合计",
							price: 200,
							unit:'',
							quantity:20,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格6：商品信息 ----------
			new hiprint.PrintElementTypeGroup("表格7", [{
				tid: "defaultModule.splitListDetail",
				type: "table",
				title: "商品信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品",
							field: "name",
							width: 200,
							align: "left"
						},
						{
							title: "商品规格",
							field: "format",
							width: 210,
							align: "left"
						},
						{
							title: "单价",
							field: "price",
							width: 150,
							align: "left"
						},
						{
							title: "计量单位",
							field: "unit",
							width: 80,
							align: "left"
						},
						{
							title: "数量",
							field: "quantity",
							width: 100,
							align: "left"
						}
					]
				],
				options: {
					title: "商品信息",
					field: "splitDetail",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: 2,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: "",
							name: "",
							format: "合计",
							price: 200,
							unit:'',
							quantity:20,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格6：商品信息 ----------
			new hiprint.PrintElementTypeGroup("表格7", [{
				tid: "defaultModule.assemblyListDetail",
				type: "table",
				title: "商品信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品",
							field: "name",
							width: 200,
							align: "left"
						},
						{
							title: "商品规格",
							field: "format",
							width: 210,
							align: "left"
						},
						{
							title: "单价",
							field: "price",
							width: 150,
							align: "left"
						},
						{
							title: "计量单位",
							field: "unit",
							width: 80,
							align: "left"
						},
						{
							title: "数量",
							field: "quantity",
							width: 100,
							align: "left"
						}
					]
				],
				options: {
					title: "商品信息",
					field: "assemblyDetail",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: 2,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							quantity:10
						},
						{
							serialNo: "",
							name: "",
							format: "合计",
							price: 200,
							unit:'',
							quantity:20,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 优化后的表格6：商品信息 ----------
			new hiprint.PrintElementTypeGroup("表格8", [{
				tid: "defaultModule.inventorySheetDetail",
				type: "table",
				title: "商品信息",
				columns: [
					[{
							title: "序号",
							field: "serialNo",
							width: 60,
							align: "center"
						},
						{
							title: "商品",
							field: "name",
							width: 130,
							align: "left"
						},
						{
							title: "商品规格",
							field: "format",
							width: 130,
							align: "left"
						},
						{
							title: "单价",
							field: "price",
							width: 80,
							align: "left"
						},
						{
							title: "计量单位",
							field: "unit",
							width: 80,
							align: "left"
						},
						{
							title: "账存数量",
							field: "accountBalance",
							width: 80,
							align: "left"
						},
						{
							title: "实际数量",
							field: "actualNumbers",
							width: 80,
							align: "left"
						},
						{
							title: "盈亏数",
							field: "deficiency",
							width: 80,
							align: "left"
						},
						{
							title: "盈亏额",
							field: "lossAmount",
							width: 80,
							align: "left"
						}
					]
				],
				options: {
					title: "商品信息",
					field: "commodityStockDetail",
					borderType: "full",
					stripe: true,
					headerBackground: "#f5f5f5",
					headerAlign: "center",
					rowHeight: 32,
					testData: [{
							serialNo: 1,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							accountBalance:10,
							actualNumbers:8,
							deficiency:2,
							lossAmount:200
						},
						{
							serialNo: 2,
							name: "测试商品",
							format: "120*120",
							price: 100,
							unit:'个',
							accountBalance:10,
							actualNumbers:8,
							deficiency:2,
							lossAmount:200
						},
						{
							serialNo: "",
							name: "",
							format: "合计",
							price: "",
							unit:'',
							accountBalance:20,
							actualNumbers:16,
							deficiency:4,
							lossAmount:400,
							__style__: {
								fontWeight: "bold",
								backgroundColor: "#f9f9f9"
							}
						}
					]
				}
			}]),

			// ---------- 辅助元素（保持不变） ----------
			new hiprint.PrintElementTypeGroup("辅助2", [{
				tid: "defaultModule.vline",
				title: "竖线",
				type: "vline"
			}]),
			new hiprint.PrintElementTypeGroup("辅助", [{
				tid: "defaultModule.hline",
				title: "横线",
				type: "hline"
			}])
		]);
	};

	return {
		addElementTypes: addElementTypes,
	};
}